module.exports = __webpack_public_path__ + "media/video1.8776b515.mp4";